// public/js/modules/userProfileCache.js


const profilesCache = new Map();
const PROFILE_CACHE_TTL_MS = 3 * 60 * 1000; 


let currentEasternDate = getEasternDateString();

function getEasternDateString() {
    const now = new Date();
    const easternOffset = -4;
    const nowEastern = new Date(now.getTime() + (easternOffset * 60 * 60 * 1000));
    return nowEastern.toDateString();
}


setInterval(() => {
    const newEasternDate = getEasternDateString();
    if (newEasternDate !== currentEasternDate) {
        console.log(`[UserProfileCache] Day rolled over from ${currentEasternDate} to ${newEasternDate}. Clearing cache to fetch fresh daily stats.`);
        currentEasternDate = newEasternDate;
        clearProfileCache();
    }
}, 60000);


export function getProfileFromCache(userId) {
    const cached = profilesCache.get(userId);
    if (!cached) return undefined;
    if (Date.now() - cached.ts > PROFILE_CACHE_TTL_MS) {
        profilesCache.delete(userId);
        return undefined;
    }
    return cached.profile;
}


export function setProfileInCache(userId, profileData) {
    if (userId && profileData) {
        profilesCache.set(userId, { profile: profileData, ts: Date.now() });
    }
}


export function clearProfileCacheEntry(userId) {
    if (userId) {
        profilesCache.delete(userId);
    }
}


export function clearProfileCache() {
    profilesCache.clear();
}